import React, { DOMAttributes } from 'react';

import { classNames } from '@/helpers/classNames';
import { Capacitor } from '@capacitor/core';
import { SvgIcon, useMediaQuery } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import styles from './SmallSongCardButton.module.scss';

const isCapacitor = Capacitor.isNativePlatform();

type SmallSongCardButtonProps = {
	className?: string;
	icon?: React.ElementType<any>;
	dashed?: boolean;
	fullWidth?: boolean;
	isLoading?: boolean;
	onClick?: DOMAttributes<HTMLDivElement>['onClick'];
};

export const SmallSongCardButton: React.FC<SmallSongCardButtonProps> = ({
	className,
	children,
	icon,
	dashed,
	fullWidth,
	isLoading,
	onClick,
}) => {
	const classes = classNames([
		styles.smallsongcardbutton,
		!isCapacitor && styles['hover'],
		fullWidth && styles['fullWidth'],
		isLoading && styles['loading'],
		className,
	]);

	return (
		<div
			onClick={(event) => {
				if (onClick) {
					onClick(event);
				}
			}}
			className={classes}
			style={{ borderStyle: dashed ? 'dashed' : 'solid' }}
		>
			{isLoading ? (
				<Skeleton variant="rect" height="100%" width="100%" />
			) : (
				<>
					{icon && (
						<div className={classNames([styles['icon']])}>
							<SvgIcon component={icon} />
						</div>
					)}
					<div className={styles['label']}>{children}</div>
				</>
			)}
		</div>
	);
};
